import Vue from 'vue'

const api = {
    baseUrl: `${window.location.pathname}api.php`,

    install (Vue, options) {
        if (window.location.hostname === 'localhost') {
            // api.baseUrl = 'http://localhost:8000/api.php'
            api.baseUrl = 'https://www.agsmperte.it/registrazione/api.php'
        }
        // this.baseUrl =
        Vue.prototype.$apiCall = function (path, params = {}) {
            return fetch(`${api.baseUrl}?path=${path}`, Object.assign({ method: 'GET', mode: 'cors' }, params))
                .then(res => res.json())
                .catch(console.warn)
        }
    }
}

export default api


// WEBPACK FOOTER //
// ./src/plugins/api.js